// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M8.5 3.5H13.5M8.5 8H13.5M8.5 12.5H13.5',
  'M2.5 4.75L3.9 6.15L6.5 3.55M2.5 11.1L3.9 12.5L6.5 9.9',
];
